// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__CIfTe","inputDescription":"styles_inputDescription__2Uc5_"};